import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Modal, Tabs } from "antd";

import OrderDetailsLeft from "../OrderDetailsLeft/OrderDetailsLeft";
import { ordersActions } from "../../../../store/slices/orders-slices";
import OrderDetailsRight from "../OrderDetailsRight/OrderDetailsRight";
import { CancellationOrderModal } from "../CancellationOrderModal/CancellationOrderModal";
import { DishType } from "../../../../constants/enums";

const OrderDetails = ({ setIsOpenModalInfo, selectedOrderId }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("orderInfo");
  const [isShowCancellation, setIsShowCancellation] = useState(false);

  const { singleOrder, trigger } = useSelector((store) => store.orders);

  const closeModal = () => {
    setIsOpenModalInfo(false);
  };

  const dishesData = singleOrder?.dishes;

  // Calculate total cost for the day
  const totalCost = useMemo(() => {
    if (!dishesData || dishesData.length === 0) return 0;
    let total = 0;
    for (const dish of dishesData) {
      const dishes = dish.dishes;
      total += dishes.reduce((total, dishObj) => {
        let cost = Number(dishObj.dish?.cost) || 0;
        if (dishObj.type === DishType.BASE || dishObj.type === "BASE") {
          cost += Number(dishObj.proteinDish?.cost) || 0;
          cost += Number(dishObj.sauceDish?.cost) || 0;
        }
        return total + cost;
      }, 0);
    }
    return total;
  }, [dishesData]);

  useEffect(() => {
    dispatch(ordersActions.getById({ id: selectedOrderId }));
  }, [selectedOrderId, trigger, dispatch]);

  const tabItems = [
    {
      key: "orderInfo",
      label: t("order-info"),
      style: { maxHeight: "70vh", overflowY: "auto" },
      children: (
        <div>
          <OrderDetailsLeft order={singleOrder.order} totalCost={totalCost} />
        </div>
      ),
    },
    {
      key: "dishes",
      label: t("orders-menu-title-sample-dishes"),
      style: { maxHeight: "70vh", overflowY: "auto" },
      children: (
        <div>
          <OrderDetailsRight
            dishes={singleOrder.dishes}
            order={singleOrder.order}
            setIsShowCancellation={setIsShowCancellation}
            totalCost={totalCost}
          />
          {isShowCancellation && (
            <CancellationOrderModal
              setIsShowCancellation={setIsShowCancellation}
              order={singleOrder.order}
            />
          )}
        </div>
      ),
    },
  ];

  return (
    <Modal
      title={`${t("order")} ${selectedOrderId}`}
      open={true}
      onCancel={closeModal}
      footer={null}
      width={"85vw"}
      centered
    >
      <Tabs activeKey={activeTab} onChange={setActiveTab} items={tabItems} />
    </Modal>
  );
};

export default React.memo(OrderDetails);
